module.exports = __webpack_public_path__ + "static/media/count_up_bg.a1dd7fc2.jpg";